import { createContext } from "react"

/**
 * Language of the enclosing `Form`, so a Friendly Captcha widget rendered from
 * a Storyblok `captcha` blok (which knows nothing about the form) is localized
 * like the form itself.
 */
export const FrcLanguageContext = createContext(undefined)

/**
 * Whether the enclosing `Form` uses Friendly Captcha at all. Forms that require
 * a login (shop orders) turn it off: the mailer already checks the session, so
 * a captcha would only add friction for signed-in customers.
 */
export const FrcEnabledContext = createContext(true)
